"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

// This wrapper ensures the dialog is NEVER rendered during SSR
// It only renders after the client has fully mounted and hydrated
const RoleSelectionDialog = dynamic(
  () => import("@/components/role-selection-dialog").then((mod) => mod.RoleSelectionDialog),
  { 
    ssr: false,
    loading: () => null
  }
);

type ClientOnlyDialogWrapperProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const ClientOnlyDialogWrapper = ({
  open,
  onOpenChange,
}: ClientOnlyDialogWrapperProps) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    // Wait for next tick after mount to ensure hydration is complete
    const timer = setTimeout(() => {
      setShouldRender(true);
    }, 0);
    
    return () => clearTimeout(timer);
  }, []);

  // Never render on server
  if (typeof window === "undefined") {
    return null;
  }

  // Don't render until after hydration
  if (!shouldRender) {
    return null;
  }

  // Only render the dialog component when it's actually needed
  // This prevents any Portal creation when dialog is closed
  if (!open) {
    return null;
  }

  return <RoleSelectionDialog open={open} onOpenChange={onOpenChange} />;
};

